import React, { FC } from 'react';
import { WearerSummary } from 'src/components/BundleProduct/BundleOptionsProvider';
import { WearerBundleDetails } from 'src/queries/__generated__/wearerBundleDetail';
import { MediaEntry } from 'src/types/global-types';

import { ProductSwatchColors } from '../ProductDetail/ProductSwatchColors';
import { Swatch } from '../ProductDetail/ProductSwatch';

import classes from './BundleColorSection.scss';
import { StepContainer } from './StepContainer';
import { BundleInformationsAndQuantity } from './BundleInformationsAndQuantity';
import { BundleImage } from './BundleImage';

type Props = {
    currentQty: number;
    maxQty: number;
    swatches: Swatch[];
    selectedSwatchesId?: number[];
    handleBundleColorSet: (swatch: Swatch) => void;
    isSwatchDisabled: (colorId: number) => boolean;
    bundleInformation?: WearerSummary;
    bundleIndex: number;
    details?: WearerBundleDetails;
    mediaEntry?: MediaEntry;
    productUrl?: string;
};

export const BundleColorSection: FC<Props> = ({
    currentQty,
    maxQty,
    swatches,
    selectedSwatchesId,
    handleBundleColorSet,
    isSwatchDisabled,
    bundleInformation,
    bundleIndex,
    details,
    mediaEntry,
    productUrl,
}) => (
    <StepContainer>
        <div className={classes.imageAndName}>
            {bundleInformation && <BundleImage image={bundleInformation.image} altText={bundleInformation.name} />}
            <BundleInformationsAndQuantity
                currentQty={currentQty}
                maxQty={maxQty}
                bundleInformation={bundleInformation}
                details={details}
                mediaEntry={mediaEntry}
                productUrl={productUrl}
            />
        </div>
        <ProductSwatchColors
            swatches={swatches}
            onSet={handleBundleColorSet}
            isSwatchDisabled={isSwatchDisabled}
            selectedSwatchesId={selectedSwatchesId}
            bundleIndex={bundleIndex}
        />
    </StepContainer>
);
